import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { NavController, Events, LoadingController, NavParams } from 'ionic-angular';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { StoreLocatorData } from '../../providers/store-locator-data';
import { Utils } from '../../../../providers/utils';
@Component({
	selector: 'page-store-info',
	templateUrl: 'store-info.html'
})
export class StoreInfoPage extends PageBase {
	storeModel = {};
	loader: any;
	storeId = '';
	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public loadingCtrl: LoadingController,
		private navParams: NavParams,
		public storeLocatorData: StoreLocatorData
	) {
		super(settings, events, nav, userData);
		this.storeId = navParams.get('id');
	}

	initData() {
		this.storeLocatorData.getStore(this.storeId).subscribe(store => {
			console.log(store);
			if (store && store.services) {
				store.services = Utils.toArray(store.services).reverse();
			}
			this.storeModel = store;
			if (this.storeModel['storeHours'])
				this.storeModel['storeHours'] = JSON.parse(this.storeModel['storeHours']);
		});
	}

	ngAfterViewInit() {

	}

	ionViewDidEnter() {
		this.initData();
	}

	public viewWeeklyAd(store){
		this.storeLocatorData.setCurrentStore(store);
		this.nav.setRoot(this.pageRef.get('weekly-ad'));
	}
}


// WEBPACK FOOTER //
// ./src/modules/store-locator/pages/store-info/store-info.ts